import * as yup from "yup";

// Mirrors the Zitadel password complexity policy (min length 16 with upper,
// lower, number and symbol). Kept local to this screen because it is stricter
// than the legacy kayros-id policy used by ResetPassword.
const ZITADEL_PASSWORD = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^A-Za-z0-9]).{16,}$/;

const validation = (errors) => {
  return yup.object().shape({
    password: yup
      .string()
      .typeError(errors.REQUIRED)
      .matches(ZITADEL_PASSWORD, errors.PASSWORD.SET_FORMAT)
      .required(errors.REQUIRED),
    confirmPassword: yup
      .string()
      .typeError(errors.REQUIRED)
      .oneOf([yup.ref("password"), null], errors.PASSWORD.MATCH)
      .required(errors.REQUIRED),
  });
};

export default validation;
